export var isPageInvalid=function(page,lastPage){return page<1||page>lastPage&&0!==lastPage};